import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { findByTurma } from "../AlunoTurma/api-aluno-turma";
import TurmaComboBox from '../Turma/UI/TurmaComboBox';
import AlunoTurmaComboBox from '../AlunoTurma/UI/AlunoTurmaComboBox';
import { errorMessage } from '../../util/ConfirmAlertUtil';
import { Grid } from '@mui/material';
import GridPaper from '../../util/GridPaper';

const useStyles = makeStyles(theme => ({
    form: {
        width: '100%', // Fix IE 11 issue.
    },
    title: {
        paddingTop: '20px;'
    },
    submit: {
        // margin: theme.spacing(3, 0, 2),
    },
    loading: {
        margin: '20px'
    }
}));

export default function RelatorioAlunoForm({ turmas }) {
    const classes = useStyles();
    const [relatorioAluno, setRelatorioAluno] = useState({
        numeroBimestre: 1
    });
    const [turma, setTurma] = useState();
    const [alunosTurma, setAlunosTurma] = useState([]);

    useEffect(() => {
        if (turma) {
            findByTurma(turma.codigo).then((data) => {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    setAlunosTurma(data);
                }
            });
        }

    }, [turma]);

    const handleTurmaChange = (event) => {
        setTurma(turmas.find(t => t.codigo === event.target.value));
    }

    const handleAlunoTurmaChange = (event) => {
        setRelatorioAluno({
            ...relatorioAluno,
            alunoTurma: alunosTurma.find((at) => at.codigo === event.target.value)
        });
    }

    return (
        <Container >
            <Typography className={classes.title} variant="body1">
                Por Aluno
            </Typography>
            <GridPaper container justifyContent='center' spacing={3}>
                <Grid size={12}>
                    <TurmaComboBox
                        turmas={turmas}
                        turma={turma}
                        handleTurmaChange={handleTurmaChange}
                    />
                </Grid>
                {turma ?
                    <Grid size={12}>
                        <AlunoTurmaComboBox
                            alunosTurma={alunosTurma}
                            alunoTurma={relatorioAluno.alunoTurma}
                            handleAlunoTurmaChange={handleAlunoTurmaChange}
                        />
                    </Grid> : ''
                }
                <Grid>
                    <Button
                        component={Link}
                        to={{
                            pathname: '/confere-registro-aula-falta',

                        }}
                        state={{
                            alunoTurma: relatorioAluno.alunoTurma ? relatorioAluno.alunoTurma : null
                        }}
                        type="button"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        Confere Registro Aulas e Faltas
                    </Button>
                </Grid>
                <Grid>
                    <Button
                        component={Link}
                        to={{
                            pathname: '/relatorio-frequencia-web',

                        }}
                        state={{
                            alunoTurma: relatorioAluno.alunoTurma ? relatorioAluno.alunoTurma : null
                        }}
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}>
                        Frequência
                    </Button>
                </Grid>
            </GridPaper>
        </Container >
    );
}